import { ChevronLeftIcon } from '@fingertip/icons'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { BookerBack } from '@/components/booking/booker/nav/booker-back'
import { useBookerNav } from '@/components/booking/booker/nav/use-booker-nav'
import { Button } from '@/components/ui/button'
import { BookingStage } from '@/lib/stores/booker-store'
import { cn } from '@/lib/utils'

type Props = {
  previousStage: BookingStage | null
  onRootBack?: () => void
}

export const BookerTopNav = observer(({ previousStage, onRootBack }: Props) => {
  const { t } = useTranslation()

  const { isFirstStage } = useBookerNav()

  if (isFirstStage) {
    return null
  }

  return (
    <div
      className={cn('flex shrink', {
        'mb-4': (!!onRootBack && !previousStage) || previousStage,
      })}
    >
      {!!onRootBack && !previousStage && (
        <Button variant="muted" size="sm" onClick={onRootBack} type="button">
          <ChevronLeftIcon className="size-4 mr-1" />
          {t('back')}
        </Button>
      )}

      {previousStage && <BookerBack stage={previousStage} />}
    </div>
  )
})
